module.exports = __webpack_public_path__ + "img/bowo.699e9819.png";